<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    @new-confirm-and-add-other-action="createEntry(true)"
    :saveAndAddOtherButtonEnabled="true"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_TABLE_PRICE_PRODUCTS_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.tablePriceProduct;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(tablePriceProduct, saveAndAddOther) {
      // console.log("SUBCULTURE", tablePriceProduct, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(tablePriceProduct, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_TABLE_PRICE_PRODUCT_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(tablePriceProduct, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createTablePriceProduct.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createTablePriceProduct.talbePriceProduct);
            if (saveAndAddOther) {
              this.loadServerEntry();
              this.$refs.baseNew.newDialog = true;
            }
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function(saveAndAddOther=false) {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry, saveAndAddOther);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_TABLE_PRICE_PRODUCTS_QUERY = gql `
  {
    accountContext{
      tablePriceProduct {
        value
        commissionPercent
        itemId
        item{
          id
          name
          description
          unit{
            id
            name
          }
        }
        tablePriceId
        packagingId
        validations
      }
      allTablePrices {
        id
        description
      }
    } 
  }
`;

const CREATE_TABLE_PRICE_PRODUCT_MUTATION = gql `
  mutation($input: TablePriceProductCreateInputObject!) {
    createTablePriceProduct(input: $input) {
      tablePriceProduct {  
        id
        value
        commissionPercent
        itemId
        tablePriceId
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
